import React, { useEffect } from 'react'
import SnapGuide from './SnapGuide'
import Section from './Section/SectionContainer'
import SelectableContainer from './Block/SelectableContainer'
import Discuss from '../Discuss'
import MultiSelect from './MultiSelect'
import styled from 'react-emotion'
import { color } from '../../style'
import useTitle from '../../hooks/useTitle'

export function Board({
  board,
  blockGroups,
  sections,
  mode,
  selection,
  dragGuides,
  placement,
  colWidth,
  hideTools,
  scrollToSection,
  updateViewDate,
  className
}) {
  if (!board || !sections) return null

  useTitle('title.board', { board: board.name })
  useEffect(() => {
    updateViewDate(board.id)
  }, [board.id])

  return (
    // acutal content, scrolls
    <div className={className} onTouchStart={hideTools} onTouchMove={hideTools}>
      {/* Sections */}
      <div style={{ background: 'white' }}>
        {[...sections.values()].map(({ id }, i) => (
          <Section first={i === 0} sectionId={id} key={id} scrollToSection={scrollToSection} />
        ))}
      </div>

      {/* Blocks */}
      {Object.values(blockGroups)
        .sort((a, b) => (a.stackingOrder || 0) - (b.stackingOrder || 0))
        .map((group, i, { length }) => {
          let layer = null
          if (i === 0) layer = 'back'
          else if (i === length - 1) layer = 'front'

          return (
            <SelectableContainer
              group={group}
              key={group.id}
              layer={layer}
              board={board}
            />
          )
        })}

      {/* Multi Select Drag */}
      {selection && <MultiSelect area={selection.scale(colWidth).style} />}

      {/* Discuss */}
      {mode === 'discuss' && <Discuss boardId={board.id} />}

      {/* Snap Guides  */}

      {placement &&
        placement.guides.map((guide, i) => (
          <SnapGuide
            type={guide.type}
            top={guide.top * colWidth}
            left={guide.left * colWidth}
            length={guide.length * colWidth}
            colWidth={colWidth}
            key={i}
          />
        ))}

      {dragGuides &&
        dragGuides.guides.map((guide, i) => (
          <SnapGuide
            type={guide.type}
            top={guide.top * colWidth}
            left={guide.left * colWidth}
            length={guide.length * colWidth}
            colWidth={colWidth}
            key={i}
          />
        ))}
    </div>
  )
}

export default styled(Board)(({ placementBlock, mode }) => ({
  label: 'Board',
  position: 'relative',
  width: '100%',
  cursor: placementBlock && 'crosshair',
  paddingBottom: mode === 'edit' && '50vh',
  background: mode === 'edit' && color.greyBlock,
  minHeight: mode === 'edit' && 'calc(100vh - 30px)'
}))
